import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Database } from 'lucide-react';
import SearchTab from './SearchTab';
import BrowseTab from './BrowseTab';

type TabId = 'search' | 'browse';

const TABS: Array<{ id: TabId; label: string }> = [
  { id: 'search', label: 'Поиск по хранилищу' },
  { id: 'browse', label: 'Файлы и папки' },
];

export default function DataSourcesPage() {
  const [tab, setTab] = useState<TabId>('search');

  return (
    <Box sx={{ p: { xs: 2, md: '32px 48px' }, maxWidth: 1600, mx: 'auto', width: '100%' }}>
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          mb: 3,
          gap: 2,
          flexWrap: 'wrap',
        }}
      >
        <Box>
          <Typography sx={{ fontSize: 22, fontWeight: 800, letterSpacing: '-0.4px', mb: 0.5 }}>
            Источники данных
          </Typography>
          <Typography sx={{ fontSize: 13, color: 'var(--color-text-muted)' }}>
            Корпоративное хранилище документов и медиа-активов
          </Typography>
        </Box>
        {/* Бейдж подключения DAM */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            px: 1.75,
            py: 1,
            bgcolor: 'rgba(5,150,105,0.08)',
            border: '1px solid rgba(5,150,105,0.25)',
            borderRadius: 'var(--radius-md)',
          }}
        >
          <Database size={14} style={{ color: '#059669' }} />
          <Typography sx={{ fontSize: 12.5, fontWeight: 650, color: '#059669' }}>
            Корпоративное DAM
          </Typography>
          <Box
            sx={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              bgcolor: '#059669',
              boxShadow: '0 0 0 3px rgba(5,150,105,0.18)',
            }}
          />
          <Typography sx={{ fontSize: 12, color: '#059669' }}>Подключено</Typography>
        </Box>
      </Box>

      {/* Вкладки (стиль pill-таб из AppLayout) */}
      <Box
        sx={{
          display: 'inline-flex',
          gap: '2px',
          background: 'rgba(20,116,255,0.06)',
          border: '1px solid rgba(20,116,255,0.12)',
          borderRadius: '9px',
          p: '3px',
          mb: 3,
        }}
      >
        {TABS.map((t) => {
          const isActive = tab === t.id;
          return (
            <Box
              key={t.id}
              onClick={() => setTab(t.id)}
              sx={{
                px: 1.75,
                py: '5px',
                borderRadius: '6px',
                fontSize: 12.5,
                fontWeight: 600,
                cursor: 'pointer',
                userSelect: 'none',
                transition: 'all 0.15s ease',
                color: isActive ? 'var(--color-text-primary)' : 'var(--color-text-muted)',
                background: isActive ? 'rgba(255,255,255,0.92)' : 'transparent',
                boxShadow: isActive ? '0 1px 4px rgba(20,116,255,0.14)' : 'none',
                '&:hover': { color: 'var(--color-text-primary)' },
              }}
            >
              {t.label}
            </Box>
          );
        })}
      </Box>

      {tab === 'search' ? <SearchTab /> : <BrowseTab />}
    </Box>
  );
}
